<template>
  <div class="app-body-1260px-auto">
    <!-- 顶栏 -->
    <HeaderMain></HeaderMain>
    <div class="app-body-1160px">
      <div id="app-user-menu" v-if="loaded">
        <div id="app-user-basic-info">
          <el-upload action="" :show-file-list="false" :http-request="uploadFile" :before-upload="beforeAvatarUpload">
            <img :src="this.$store.state.userInfo.avatar" id="app-user-basic-info-img" alt="pic">
          </el-upload>
          <p id="app-user-basic-info-name">{{ this.$store.state.userInfo.account }}</p>
          <p id="app-user-basic-info-id">id: {{ this.$store.state.userInfo.id }}</p>
        </div>
        <div id="app-user-menu-body">
          <el-menu id="app-user-menu-el"
                   :default-active="activeIndex"
                   background-color="#eff1f4"
                   active-text-colo="#000000">
            <el-menu-item index="1" v-on:click="changeIndex('1')">
              <em class="el-icon-user"></em>
              <span slot="title">个人信息</span>
            </el-menu-item>
            <el-menu-item index="2" v-on:click="changeIndex('2')" disabled>
              <em class="el-icon-message"></em>
              <span slot="title">我的信息</span>
            </el-menu-item>
            <el-menu-item index="3" v-on:click="changeIndex('3')" disabled>
              <em class="el-icon-star-on"></em>
              <span slot="title">我的收藏</span>
            </el-menu-item>
            <el-menu-item index="4" v-on:click="changeIndex('4')" disabled>
              <em class="el-icon-edit"></em>
              <span slot="title">我的投稿</span>
            </el-menu-item>
            <el-menu-item index="5" v-on:click="changeIndex('5')">
              <em class="el-icon-film"></em>
              <span slot="title">我的资产</span>
            </el-menu-item>
            <el-menu-item index="6" v-on:click="changeIndex('6')">
              <em class="el-icon-setting"></em>
              <span slot="title">设置</span>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
      <div id="app-user-right">
        <PersonalInfo v-if="activeIndex === '1'"></PersonalInfo>
        <MyMessage v-if="activeIndex === '2'"></MyMessage>
        <MyProperty v-if="activeIndex === '5'"></MyProperty>
        <AdviceSettings v-if="activeIndex === '6'"></AdviceSettings>
      </div>
    </div>
  </div>
</template>

<script>

import PersonalInfo from "@/views/user/center/PersonalInfo";
import MyProperty from "@/views/user/center/MyProperty";
import AdviceSettings from "@/views/user/center/AdviceSettings";
import MyMessage from "@/views/user/center/MyMessage";

import '@/views/user/style.css'
import {Message} from "element-ui";
import AxiosBase from "@/components/axiosBase";
import HeaderMain from "@/views/share/HeaderMain";

export default {
  name: "Center",
  components: {
    HeaderMain,
    MyProperty,
    MyMessage,
    AdviceSettings,
    PersonalInfo,
  },
  data() {
    return {
      activeIndex: '1',
      loaded: false,
      avatarInfo: {
        avatar: ''
      }
    }
  },
  mounted() {
    document.title = "斑斓魔法CG-个人中心";
  },
  methods: {
    changeIndex(var1) {
      this.activeIndex = var1;
    },
    uploadFile(fileObj) {
      let formData = new FormData();
      formData.set("file", fileObj.file);
      AxiosBase.axiosPost("/ff/upload", formData, {
        headers: {
          "Content-type": "multipart/form-data"
        }
      }).then(response => {
        if (response !== 0) {
          this.avatarInfo.avatar = "https://img.blendermagic.cn/normal/" + response.data
          AxiosBase.axiosPost("/user/change-avatar", this.avatarInfo).then(response2 => {
            if (response2 !== 0) {
              Message({
                showClose: true,
                message: response2.data,
                type: 'success'
              });
              this.$store.state.userInfo.avatar = this.avatarInfo.avatar;
            }
          })
        }
      })
    },
    beforeAvatarUpload(file) {
      const fileType = file.type;
      const fileCheck = fileType === 'image/jpeg' || fileType === 'image/gif' || fileType === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!fileCheck) {
        this.$message.error('上传头像图片只能是 JPG/GIF/JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return fileCheck && isLt2M;
    }
  }
}
</script>

<style scoped>

#app-user-menu {
  height: 850px;
  width: 250px;
  background-color: #eff1f4;
}

#app-user-basic-info {
  width: 200px;
  height: 260px;
  /*background-color: #FF8A00;*/
  text-align: center;
  border-bottom: 1px solid #000000;
  margin-left: 25px;
}

#app-user-basic-info-img {
  border-radius: 64px;
  margin: 30px auto auto;
  width: 128px;
  height: 128px;
}

#app-user-basic-info-name {
  margin-top: 15px;
  font-size: 20px;
}

#app-user-basic-info-id {
  margin-top: 10px;
  font-size: 5px;
}

#app-user-menu-body {
  width: 100%;
  /*border-top: 1px solid rgba(20, 20, 20, 0.4);*/
  padding-top: 10px;
}

#app-user-right {
  position: absolute;
  top: 10px;
  bottom: 0;
  right: 0;
  left: 260px;
}

</style>